import { Component, EventEmitter, Input, Output } from '@angular/core';

import { PriceDialogComponent } from '../price-dialog/price-dialog.component'; 

import { TextDescriptionDialogComponent } from '../text-description-dialog/text-description-dialog.component'; 
import { AudioDescriptionDialogComponent } from '../audio-description-dialog/audio-description-dialog.component'; 
import { QrCodeDescriptionDialogComponent } from '../qr-code-description-dialog/qr-code-description-dialog.component'; 
import { PhotoDialogComponent } from '../photo-dialog/photo-dialog.component'; 

import {MatDialog, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';

import { formatDate } from '@angular/common';

import { GestockService } from '../services/gestock.service';


interface Produit {
  id: string;
  nom: string;
  code: string;
  prix: number;
  imageUrl: string;
  dejaAjoute?: boolean;
  quantite?: number;
}

@Component({
  selector: 'app-liste-produits',
  templateUrl: 'liste-produits.component.html',
  styleUrls: ['liste-produits.component.css']
})
export class ListeProduitsComponent {
  @Input() products: any;
  @Output() ajout = new EventEmitter<Produit>();
  @Output() retrait = new EventEmitter<Produit>();

  
  previewProducts: any[] = [];

  selectedProducts: any[] = [];

  categories: string[] = ['Accessoires', 'Pièces détachées', 'Motos' ]; 
  newCategory: string = '';

  searchTerm: string = '';
  page: number = 1;

  showSearch = false;
  showFilter = false;
  selectedCategories: string[] = [];

  constructor(private dialog: MatDialog, private configServer: GestockService) {}


  ajouter(produit: Produit) {
    produit.dejaAjoute = true;
    produit.quantite = 1;
    this.ajout.emit(produit);
  }

  incrementer(produit: Produit) {
    if (produit.quantite !== undefined) produit.quantite++;
    this.ajout.emit(produit);
  }

  decrementer(produit: Produit) {
    if (produit.quantite && produit.quantite > 1) {
      produit.quantite--;
      this.ajout.emit(produit);
    } else {
      this.retirer(produit);
    }
  }

  retirer(produit: Produit) {
    produit.dejaAjoute = false;
    produit.quantite = 0;
    this.retrait.emit(produit);
  }

  get filteredProducts() {
    return this.products.filter(product => {
      const matchesSearch = this.searchTerm === '' || product.name.toLowerCase().includes(this.searchTerm.toLowerCase());
      const matchesCategory = this.selectedCategories.length === 0 || this.selectedCategories.includes(product.category);
      return matchesSearch && matchesCategory;
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.searchTerm = filterValue.trim().toLowerCase();
  }


  toggleSearch() {
    this.showSearch = !this.showSearch;
    this.showFilter = false; // Cache le filtre si on affiche la recherche
  }

  toggleFilter() {
    this.showFilter = !this.showFilter;
    this.showSearch = false; // Cache la recherche si on affiche les filtres
  }

  getUniqueCategories(): string[] {
    const categories: string[] = [];
    this.products.forEach(product => {
      if (!categories.includes(product.category)) {
        categories.push(product.category);
      }
    });
    return categories;
  }

  openPriceDialog(product: any) {
    const dialogRef = this.dialog.open(PriceDialogComponent, {
      width: '350px',
      data: { product }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        product.prices = result; // Remplace les prix s’ils ont été modifiés
      }
    });
  }


  openTextDescriptionDialog(product: any) {
    const dialogRef = this.dialog.open(TextDescriptionDialogComponent, {
      width: '400px',
      data: { product }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result?.description !== undefined) {
        product.description = result.description;
        //this.updateProductInStock(product);
       //this.showSuccessSnackBar('Description mise à jour avec succès.');
      }
    });
  }

  openAudioDescriptionDialog(product: any) {
    const dialogRef = this.dialog.open(AudioDescriptionDialogComponent, {
      width: '400px',
      data: { product }
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  openQrCodeDialog(product: any) {
    this.dialog.open(QrCodeDescriptionDialogComponent, {
      width: '300px',
      data: { product }
    });
  }

  openPhotoDialog(product: any) {
    const dialogRef = this.dialog.open(PhotoDialogComponent, {
      width: '500px',
      data: { product }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result?.imageUrl !== undefined) {
      }
    });
  }



}
